import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Car2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m570 555c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m210 555c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m615 480h60v30h-60z' />
    <path d='m690 510h-30v-120h-53.71l-47.04-82.33c-7.99-13.99-22.96-22.67-39.07-22.67h-198.75l-100 105h-86.43c-8.27 0-15 6.73-15 15v75h45v30h-75v-105c0-24.81 20.19-45 45-45h73.57l100-105h211.61c26.85 0 51.8 14.48 65.12 37.79l38.41 67.21h66.29z' />
    <path d='m250 480h280v30h-280z' />
    <path d='m570 390h-360s0-30 0-30h330c16.57 0 30 13.43 30 30z' />
    <path d='m420 285h30v105h-30z' />
  </IconBase>
));

Car2.displayName = 'Car2';

export default Car2;
